import React, { useEffect, useRef, useState } from 'react'
import useOutsideClick from 'CustomHooks/useOutsideClick'
import AddNewTagPopup from 'Popups/AddNewTagPopup/AddNewTagPopup'

const TaskSelectBox = ({ label, TagsList, selectedTags, onChange, onTagListChange }) => {
    const [showList, setShowList] = useState(false)
    const [allTags, setAllTags] = useState([])
    const [newLabelPopup, setNewLabelPopup] = useState(false)
    const maindiv = useRef(null)
    const parentdiv = useRef(null)

    useOutsideClick(parentdiv, setShowList);
    // const handleFocus = () => {
    //     // setShowList(true)
    //     maindiv.current.classList.add("tagselectboxDiv")

    // }
    // const handleBlur = (e) => {
    //     maindiv.current.classList.remove("tagselectboxDiv")
    //     // setShowList(false)
    // }

    const hanleDeleteTag = (tag) => {
        const updatedTags = selectedTags.filter((t) => t.tagId !== tag.tagId)
        onChange(updatedTags)
        setShowList(false)

    }
    const handleAddTag = (tag) => {
        const obj = {
            "addedBy": "",
            "inActive": false,
            "taskId": 0,
            "tagId": tag.id,
            tagName: tag.label.split(":")[1],
            colorCode: tag.label.split(":")[0]
        }
        const newTags = [...selectedTags, obj]
        setShowList(false)
        onChange(newTags)

    }

    const openCreateLabel = () => {
        setNewLabelPopup(true)
    }

    const closeCreateLabel = (tag) => {

        if (tag) {
            const newTagsList = [...TagsList, tag]
            onTagListChange(newTagsList)
        }
        setNewLabelPopup(false)
    }


    const handleParentDiv = () => {
        // inputref.current.focus()
        setShowList(true)
    }
    useEffect(() => {
        const tagss = TagsList.filter(tag => !selectedTags.map(t => t.tagId).includes(tag.id))
        setAllTags(tagss)
    }, [TagsList, selectedTags])

    return (
        <div>
            {label ? <p className='mb-2 text-base font-semibold'>{label}</p> : null}
            {newLabelPopup && <AddNewTagPopup onClose={closeCreateLabel} tagId={null} allowActive={false} />}
            <div ref={parentdiv} className='relative'>
                <div onClick={handleParentDiv} ref={maindiv} className='relative flex flex-wrap items-center gap-3 p-1 border border-gray-200 rounded min-h-9 '>
                    {selectedTags.map((tag, i) => {
                        return (
                            <div className='flex items-center gap-3 px-2 text-sm font-semibold bg-gray-100 rounded' key={tag.id + i}>
                                <span style={{ background: tag.colorCode }} className={`rounded-full  block size-3`} />
                                <p> {tag.tagName}</p>
                                <img onClick={() => hanleDeleteTag(tag)} className={`cursor-pointer hover:bg-red-200 rounded-full`} src=' /img/roundcross.svg' alt='cross' />
                            </div>
                        )
                    })}
                    <img className="absolute right-4" src=' /img/arrowDown.svg' alt='arrowDown' />
                    {/* <input ref={inputref} onFocus={handleFocus} onChange={handleChange} onBlur={handleBlur} className='px-1 outline-none min-w-2 ' /> */}
                </div>
                {
                    showList ? (
                        <ul className='absolute z-[2] w-full bg-white border border-gray-300 rounded-md max-h-40 overflow-y-auto shadow-xl top-[120%]'>
                            <li onClick={openCreateLabel} className='px-3 py-1 text-base font-semibold text-center border-b cursor-pointer text-primary hover:bg-gray-200' > Create Tag</li>
                            {allTags.map((tag) => {
                                return (
                                    <li onClick={() => handleAddTag(tag)} key={tag.name} className='px-3 py-1 text-sm font-semibold border-b cursor-pointer hover:bg-gray-200' ><span style={{ background: tag.label.split(":")[0] }} className={`rounded-full mr-2  inline-block size-3`}></span>{tag.label.split(":")[1]}</li>
                                )
                            })}
                        </ul>
                    ) : null
                }

            </div>
        </div>
    )
}

export default TaskSelectBox